import { Injectable } from "@angular/core";
import { HttpService } from "@services/http-service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { User } from "@models/user";
import { SingleResponse } from "../../responses/single.response";
import { map } from "rxjs/operators";
import { UserService } from "@services/user.service";
import { LoginRequest } from "@requests/auth/login.request";
import { PasswordResetRequest } from "@requests/auth/password-reset.request";

@Injectable({
  providedIn: "root",
})
export class AuthService extends HttpService {
  constructor(private http: HttpClient, private userService: UserService) {
    super();
  }

  public csrf(): Observable<unknown> {
    return this.http.get<unknown>(`${this.baseUrl}/sanctum/csrf-cookie`, { withCredentials: true });
  }

  public login(data: LoginRequest): Observable<User> {
    return this.http
      .post<SingleResponse<User>>(`${this.apiUrl}/login`, data, { withCredentials: true })
      .pipe(
        map((response) => {
          this.userService.setUser(response.data);
          return response.data;
        })
      );
  }

  public forgot(email: string): Observable<unknown> {
    return this.http.post<unknown>(`${this.apiUrl}/forgot-password`, { email });
  }

  public reset(request: PasswordResetRequest): Observable<unknown> {
    return this.http.post<unknown>(`${this.apiUrl}/reset-password`, request);
  }

  public logout(): Observable<unknown> {
    return this.http.post(`${this.apiUrl}/logout`, {}).pipe(
      map((response) => {
        this.userService.removeUser();
        return response;
      })
    );
  }
}
